import { render, staticRenderFns } from "./BarraSuperior.vue?vue&type=template&id=67245784&scoped=true"
import script from "./BarraSuperior.vue?vue&type=script&lang=js"
export * from "./BarraSuperior.vue?vue&type=script&lang=js"
import style0 from "./BarraSuperior.vue?vue&type=style&index=0&id=67245784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67245784",
  null
  
)

export default component.exports